import { render, staticRenderFns } from "./desktopArch.vue?vue&type=template&id=56e48fb4"
import script from "./desktopArch.vue?vue&type=script&lang=js"
export * from "./desktopArch.vue?vue&type=script&lang=js"
import style0 from "./desktopArch.vue?vue&type=style&index=0&id=56e48fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports